import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

function AppFormContext({ title, lines = [], sx }) {
  return (
    <Box
      sx={{
        pb: 1.5,
        borderBottom: "1px solid",
        borderColor: "divider",
        overflowWrap: "anywhere",
        ...sx,
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: lines.length ? 0.5 : 0 }}>
        {title}
      </Typography>
      {lines.map((line, index) => (
        <Typography key={index} variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          {line}
        </Typography>
      ))}
    </Box>
  );
}

AppFormContext.propTypes = {
  title: PropTypes.node.isRequired,
  lines: PropTypes.arrayOf(PropTypes.node),
  sx: PropTypes.object,
};

export default AppFormContext;
